import { getAltenarParamsFromURL } from '@/src/utils/sports/sportsHelperWidget.ts'
import { useEffect } from 'react'

const useSportsEventsWidget = () => {
  useEffect(() => {
    const popStateFunc = () => {
      const url = new URL(document.location.href)
      const params = getAltenarParamsFromURL(url.searchParams)

      window.altenarWSDK.set({
        ...params,
        page: params.page ?? 'overview',
      })
    }

    window.addEventListener('popstate', popStateFunc)
    return () => {
      window.removeEventListener('popstate', popStateFunc)
    }
  }, [])
}

export default useSportsEventsWidget
